import { render, staticRenderFns } from "./palletDealerPage.vue?vue&type=template&id=f2e0da4e"
import script from "./palletDealerPage.vue?vue&type=script&lang=js"
export * from "./palletDealerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports